import type { ProjectDocId } from '../../../api/types'

// Stabile IDs — siehe backend/src/modules/tasks/tasks.schema.ts (PROJECT_DOC_IDS). Nur die
// Anzeigenamen leben hier im Frontend, das Backend validiert unabhängig davon.
export const PROJECT_DOC_OPTIONS: { value: ProjectDocId; label: string }[] = [
  { value: 'architecture', label: 'Architecture' },
  { value: 'core', label: 'Core' },
  { value: 'database', label: 'Database' },
  { value: 'ui', label: 'UI' },
  { value: 'third_party', label: 'Third Party' },
]

export const PROJECT_DOC_LABELS: Record<ProjectDocId, string> = Object.fromEntries(
  PROJECT_DOC_OPTIONS.map((o) => [o.value, o.label]),
) as Record<ProjectDocId, string>
